module.exports = __webpack_public_path__ + "static/pic03-3677838948c068ce88d237eaea766a51.jpg";